<script>
import axios from 'axios'

export default {
  props: ['formdata'],
  data() {
    return {
      localModel: {},
      initial:true,
    }
  },
  methods: {
    postrequest()
    {
      var form_data = new FormData();

      for ( var key in this.localModel ) {
        form_data.append(key, this.localModel[key]);
      }
      axios
          .post('https://brouwer-group.nl/wp-json/brouwer-salesforce/v1/submission', form_data)
          .then((response) => {
            console.log(response)
            window.location.href = "https://brouwer-group.nl/bedankt-inruil/"
          })
          .catch((error) => console.error(error));

    },

  },
  mounted() {
    this.localModel = this.formdata;
    this.postrequest()
  }
}
</script>


<template>



  <!------------ step form Area Start  ----------->
  <section class="step-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="/" method="get" class="form">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step active" data-title="Contact "></div>
                      <div class="progress-step active" data-title="Experiences"></div>
                      <div class="progress-step active" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step form-step-center active">
                      <h3>Bedankt voor uw offerte aanvraag. We komen zo snel mogelijk bij u terug met een voorstel.</h3>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn contact-form-btn-two-center">
                  <button class="contact-form-btn-gray" type="submit">Ga terug naar de homepagina</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->


</template>

<style scoped>

</style>